module.exports = __webpack_public_path__ + "img/no-data.1e5c7e37.png";